import { IAjaxReturnValue, IIPEDescriptor, ITenForceWindow } from "../global"

declare let window: ITenForceWindow

export const saveIPE = (
    ipe: IIPEDescriptor,
    value: number | string,
): Promise<IAjaxReturnValue[]> => {
    const { object, objectId, propertyId } = ipe
    return new Promise<IAjaxReturnValue[]>((resolve, fail) => {
        window.ipe.doSave(
            (saveCallback: unknown) =>
                (parameters: unknown, fields: unknown): void => {
                    window.TenForce.Execution.Web.Ajax.Service.SaveInPlaceField(
                        object,
                        String(objectId),
                        String(propertyId),
                        value,
                        false,
                        parameters,
                        fields,
                        saveCallback,
                        window.onAjaxError,
                    )
                },
            (result: IAjaxReturnValue[]): void => {
                window.ipe.updateAfterSaving(result[0])
                resolve(result)
            },
            (error: unknown) => fail(error),
        )
    })
}
